import React from "react";
import solar_pattern from "../assets/solar_pattern.png";

export const FanContent = () => {
  return (
    <section
      className="max-w-7xl  mx-auto mt-10 px-4 sm:px-6 md:px-8 py-12 sm:py-1
 text-center"
    >
      <div className="relative w-full h-full">
        <img
          src={solar_pattern}
          alt="Solar Pattern"
          className="w-full h-[520px] sm:h-[560px] md:h-[620px] lg:h-[680px] object-cover"
        />

        <div
          className="
        absolute inset-0 z-10
        flex flex-col items-center justify-center 
        px-6 sm:px-4 py-12 pt-56 mt-5 
    "
        >
          <h1 className="font-[Norwester] text-[52px]  xl:text-[40px] lg:text-[36px] md:text-[38px] sm:text-[24px]   text-white uppercase mb-4 sm:mb-6">
            Ready to Share Your Fan Content?
          </h1>

         <p className="font-[Inter] text-[18px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[14px] text-gray-300 mb-8 sm:mb-6 max-w-3xl leading-relaxed tracking-wide w-full p-3">
            Join Vupop now and be part of the next wave of fan content shaping
            sports broadcasting.
          </p>

          {/* App Store Buttons */}
          <div className="flex  sm:flex-row justify-center items-center gap-3 sm:gap-2 sm:px-3">
            {/* Google Play */}
            <a
              href="https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1a1a1a] hover:bg-[#2a2a2a] transition-colors 
                     px-6 py-3 sm:px-4 sm:py-3 md:px-6 md:py-4
                     rounded-lg sm:rounded-xl
                     flex items-center gap-2 sm:gap-1
                     min-w-[160px] sm:min-w-[140px] md:min-w-[200px]"
            >
              <svg
                className="w-9 h-9 sm:w-6 sm:h-6 md:w-7 md:h-7"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z"
                  fill="#00A0FF"
                />{" "}
                <path
                  d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z"
                  fill="#FF3E4C"
                />{" "}
                <path
                  d="M3.84 2.15C4.25 1.93 4.73 1.94 5.13 2.15L16.81 8.88L14.54 11.15L3.84 2.15Z"
                  fill="#00D856"
                />{" "}
                <path
                  d="M16.81 8.88L20.16 10.75C21.23 11.35 21.23 12.64 20.16 13.25L16.81 15.12L14.54 12.85L16.81 8.88Z"
                  fill="#FFCE00"
                />
              </svg>

              <div className="text-left">
                <div className="text-[14px] sm:text-xs text-gray-400">
                  GET IT ON
                </div>
                <div className="text-lg sm:text-sm md:text-lg font-semibold tracking-tight text-white">
                  Google Play
                </div>
              </div>
            </a>

            {/* App Store */}
            <a
              href="https://apps.apple.com/app/vupop/id6747295116"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1a1a1a] hover:bg-[#2a2a2a] transition-colors 
                     px-6 py-3 sm:px-2 sm:py-3 md:px-6 md:py-4
                     rounded-lg sm:rounded-xl
                     flex items-center gap-2 sm:gap-1
                     min-w-[160px] sm:min-w-[140px] md:min-w-[200px]"
            >
              <svg
                className="w-10 h-10 sm:w-6 sm:h-6 md:w-7 md:h-7 lg:w-8 lg:h-8 xl:w-9 xl:h-9"
                viewBox="0 0 24 24"
                fill="white"
              >
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>

              <div className="text-left">
                <div className="text-[14px] sm:text-xs text-gray-400">
                  Download on the
                </div>
                <div className="text-lg sm:text-sm md:text-lg font-semibold tracking-tight text-white">
                  App Store
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
